module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av372-eb095c6649a53682f174b02f30cbbcd8.jpg";